
import { ref, defineComponent, onMounted } from "vue";
import { useRoute } from "vue-router";
import io from "socket.io-client";
import { Device } from "mediasoup-client";
import HanButtonVue from "../components/Common/HanButton.vue";

export default defineComponent({
  name: "RoomView",
  setup(props, ctx) {
    // const io = require('socket.io-client');
    const isHosting = ref(true);
    const socket = io("https://testapi2.nn8qozmu.top:5000/mediasoup");
    // const socket = io("https://testapi2.nn8qozmu.top:3000/mediasoup");
    // const socket = io("http://192.168.31.138:5000/mediasoup");
    const route = useRoute();
    const { params } = route;
    const roomId = params.roomId;
    const displayRid = ref(roomId) as any;
    const nickname = localStorage.getItem("nickname");
    const users = ref([]) as any;
    // @ts-ignore
    const main = window.electronApi && window.electronApi.main;

    socket.on("connection-success", ({ socketId }) => {
      console.log({ socketId });
    });

    const playAudio1: any = () => {
      const audioElement = document.getElementById(
        "recvAudio"
      ) as HTMLAudioElement;
      console.log("played");

      audioElement
        .play()
        .catch((error) => console.error("Playback error:", error));
    };

    const produceParams: any = {
      kind: "video",
      // keyFrameRequestDelay: 30,
      rtpParameters: {
        // dtx: true,
        // maxBitrate: 1000000,
        // maxFramerate: 60,
        // adaptivePtime: true,
        codecs: [{ mimeType: "video/VP9", clockRate: 90000 }],
      },
      encodings: [
        // {
        //   rid: "r0",
        //   maxBitrate: 10000000,
        //   maxFramerate: 60,
        //   active: true,
        //   scaleResolutionDownBy: 1,
        //   dtx: false,
        // },
        // {
        //   rid: "r1",
        //   maxBitrate: 100000000000,
        //   maxFramerate: 60,
        //   // adaptivePtime: true,
        //   // dtx: true,
        //   // scalabilityMode: "S1T3",
        // },
        // {
        //   rid: "r2",
        //   maxBitrate: 100000000000,
        //   maxFramerate: 60,
        //   // adaptivePtime: true,
        //   // dtx: true,
        //   // scalabilityMode: "S1T3",
        // },
      ],
      codecOptions: {
        videoGoogleStartBitrate: 1000000,
      },
    };

    let audioParams: any;
    let videoParams: any = { produceParams };

    let device: Device;
    let rtpCapabilities: any;
    let sctpCapabilities: any;
    const sctpParameters = {
      MIS: 1024,
      OS: 1024,
      isDataChannel: true,
      maxMessageSize: 262144,
      sctpBufferedAmount: 0,
      sendBufferSize: 262144,
    };
    let audioProducer;
    let videoProducer;
    let consumer;

    let producerTransport: any;
    let consumerTransports: any[] = [];
    let isProducer = false;
    let hasProducer = ref(false);
    // let isHosting = false;

    const goConnect = async (producerOrConsumer: boolean) => {
      isProducer = producerOrConsumer;
      await getLocalStream();
      // if (isProducer) {
      //   await getLocalStream()
      // } else {
      //   device === undefined ? getRtpCapabilities() : createTransport()
      // }
    };

    // const startRecord

    const joinRoom = (): void => {
      socket.emit("join-room", { roomId, nickname }, (data: any) => {
        rtpCapabilities = data.rtpCapabilities;
        console.log("join room", data);
        isHosting.value = data.isHosting;
        users.value = data.allPeers;
        createDevice();
      });
    };

    const goLive = () => {
      isHosting.value = true;
      hasProducer.value = true;
      getLocalStream();
    };
    const goConsume = () => {
      goConnect(false);
    };

    // const createTransport = () => {
    //   isProducer ? createSendTransport() : createRecvTransport()
    // }

    if (main) {
      navigator.mediaDevices.getDisplayMedia = () => {
        // @ts-ignore
        console.log(main);

        if (main.isOSX()) {
          // @ts-ignore
          screenPickerOptions.system_preferences = true;
        }

        return new Promise(async (resolve, reject) => {
          let has_access = await main.getScreenAccess();
          if (!has_access) {
            return reject("none");
          }

          try {
            const sources = await main.getScreenSources();
            console.log(sources);

            // @ts-ignore
            const source = sources.find((source) => source.id === "screen:0:0");
            const stream = await window.navigator.mediaDevices.getUserMedia({
              audio: false,
              video: {
                frameRate: 60,
                // @ts-ignore
                cursor: "never",
                // @ts-ignore
                mandatory: {
                  chromeMediaSource: "desktop",
                  chromeMediaSourceId: source.id,
                },
              },
            });
            resolve(stream);
            // screenPickerShow(
            //   sources,
            //   async (id) => {
            //     try {
            //       const source = sources.find((source) => source.id === id);
            //       if (!source) {
            //         return reject("none");
            //       }

            //       const stream = await window.navigator.mediaDevices.getUserMedia(
            //         {
            //           audio: false,
            //           video: {
            //             mandatory: {
            //               chromeMediaSource: "desktop",
            //               chromeMediaSourceId: source.id,
            //             },
            //           },
            //         }
            //       );
            //       resolve(stream);
            //     } catch (err) {
            //       reject(err);
            //     }
            //   },
            //   {}
            // );
          } catch (err) {
            reject(err);
          }
        });
      };
    }

    const getLocalStream = async () => {
      try {
        let captureStream = await navigator.mediaDevices.getDisplayMedia({
          video: {
            frameRate: { ideal: 60, max: 60 }, // 目标 60 FPS
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            // @ts-ignore
            cursor: "never",
            // @ts-ignore
            // mandatory: {
            //   chromeMediaSource: "desktop",
            //   chromeMediaSourceId: source.id,
            // },
          },
          audio: {
            echoCancellation: false, // 关闭回声消除，提升清晰度
            noiseSuppression: false, // 关闭噪声抑制，保留更多细节
            autoGainControl: false, // 关闭自动增益，避免音量波动
            sampleRate: 48000, // 设定更高的采样率（标准 48kHz）
            channelCount: 2, // 立体声（比单声道更清晰）
          },
          /* {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          } */
        });

        // captureStream = outputStream;
        const track = captureStream.getVideoTracks()[0];

        // const playbackElement = document.getElementById("testVideo");
        // @ts-ignore
        // playbackElement.play();
        // @ts-ignore
        // captureStream = playbackElement.captureStream();

        // @ts-ignore
        // const track = captureStream.getVideoTracks()[0];
        // @ts-ignore
        // console.log(playbackElement.captureStream().getVideoTracks()[0]);

        track
          // @ts-ignore
          .applyConstraints({
            // width: { exact: 1020 },
            // height: { exact: 700 },
            // frameRate: { min: 60, ideal: 60, max: 61 },
            width: { exact: 1920 },
            height: { exact: 1080 },
            frameRate: { ideal: 60, max: 60 },
          })
          .then(() => {
            // @ts-ignore

            // const video = document.createElement("video");
            // video.srcObject = captureStream;
            // video.play();
            // const canvas = document.createElement("canvas");
            // const ctx = canvas.getContext("2d");

            // video.addEventListener("loadedmetadata", () => {
            //   canvas.width = video.videoWidth;
            //   canvas.height = video.videoHeight;

            //   function drawFrame() {
            //     ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
            //     requestAnimationFrame(drawFrame);
            //   }
            //   drawFrame();
            // });

            // 通过 canvas 创建新的 MediaStream
            // const outputStream = canvas.captureStream();
            // console.log(
            //   "111",
            //   captureStream.getVideoTracks()[0].getConstraints()
            // );
            getStreamSuccess(captureStream);
          });
        // .catch((e) => {
        //   // The constraints could not be satisfied by the available devices.
        // });
      } catch (err) {
        console.error(`Error: ${err}`);
      }
    };

    const getStreamSuccess = async (stream: MediaStream) => {
      const video: any = document.getElementById("video");
      video.srcObject = stream;

      const videoTrack = stream.getVideoTracks()[0];

      // .applyConstraints();

      audioParams = { track: stream.getAudioTracks()[0], ...audioParams };
      videoParams = { track: videoTrack, ...videoParams };

      console.log("audio tracks", stream.getAudioTracks());

      if (device === undefined) {
        await createDevice();
      }
      createSendTransport();
      // joinRoom()
      // const video: any = document.getElementById('video')
      // video.srcObject = stream
      // const track = stream.getVideoTracks()[0]
      // // const audioTrack = stream.getAudioTracks()[0]
      // produceParams = {
      //   track,
      //   ...produceParams
      // }
      // console.log('produceParams', produceParams)
      // device === undefined ? getRtpCapabilities() : createTransport()
      // video.play()
    };

    // const getRtpCapabilities = () => {
    //   socket.emit("create-room", (data: any) => {
    //     rtpCapabilities = data.rtpCapabilities;
    //     sctpCapabilities = data.sctpCapabilities;

    //     console.log("rtpCapabilities", rtpCapabilities);
    //     console.log("sctpCapabilities", sctpCapabilities);
    //     createDevice();
    //   });
    // };

    socket.on("new-producer", ({ producerId }: any) => {
      signalNewConsumerTransport(producerId);
    });

    socket.on("peer-joined", ({ socketId, peerDetails, allPeers }: any) => {
      console.log("peer-joined", socketId, peerDetails, allPeers);
      users.value = allPeers;
    });

    socket.on("user-list", (data: any) => {
      console.log("user-list", data);
      users.value = data.allPeers;
    });

    const getProducers = () => {
      socket.emit("getProducers", (producerIds: []) => {
        console.log("producerIds", producerIds);
        producerIds.forEach((producerId) =>
          signalNewConsumerTransport(producerId)
        );
      });
    };

    const createDevice = async () => {
      try {
        device = new Device();
        await device.load({
          routerRtpCapabilities: rtpCapabilities,
        });

        sctpCapabilities = device.sctpCapabilities;

        console.log("createDevice");

        console.log("Return Router RTP Capabilities", rtpCapabilities);

        console.log("Device RTP Capabilities", device.rtpCapabilities);

        console.log("Device SCTP Capabilities", device.sctpCapabilities);

        // if (!isHost) {
        //   console.log('get producers')

        //   getProducers()
        // }
        // createSendTransport()
        getProducers();
      } catch (err) {
        console.error(err);
      }
    };

    const createSendTransport = () => {
      // console.log("sctpCapabilities", { sender: true, sctpCapabilities });

      socket.emit(
        "createWebRtcTransport",
        { sender: true, sctpParameters },
        ({ params }: any) => {
          if (params.error) {
            console.log(params.error);
            return;
          }
          // let sctpParameters = {
          //   MIS: 1024,
          //   OS: 1024,
          //   isDataChannel: true,
          //   maxMessageSize: 262144,
          //   port: 5000,
          //   sctpBufferedAmount: 0,
          //   sendBufferSize: 262144,
          // };
          // params.sctpParameters = sctpParameters;

          console.log(params);
          producerTransport = device.createSendTransport(params);
          producerTransport.on(
            "connect",
            async ({ dtlsParameters }: any, callback: any, errback: any) => {
              try {
                await socket.emit("transport-connect", {
                  // transportId: producerTransport.id,
                  dtlsParameters,
                });

                callback();
              } catch (error) {
                errback(error);
              }
            }
          );

          producerTransport.on(
            "produce",
            async (parameters: any, callback: any, errback: any) => {
              console.log(parameters);
              try {
                await socket.emit(
                  "transport-produce",
                  {
                    // transportId: producerTransport.id,
                    kind: parameters.kind,
                    rtpParameters: parameters.rtpParameters,
                    appData: parameters.appData,
                    sctpParameters: parameters.sctpParameters,
                  },
                  ({ id, producerExist }: any) => {
                    console.log(id);
                    callback(id);

                    if (producerExist) getProducers();
                  }
                );
              } catch (error) {
                errback(error);
              }
            }
          );

          connectSendTransport();
        }
      );
    };

    const signalNewConsumerTransport = (remoteProducerId: any) => {
      socket.emit(
        "createWebRtcTransport",
        { consumer: true, sctpParameters },
        ({ params }: any) => {
          if (params.error) {
            console.log(params.error);
            return;
          }
          // let sctpParameters = {
          //   MIS: 1024,
          //   OS: 1024,
          //   isDataChannel: true,
          //   maxMessageSize: 262144,
          //   port: 5000,
          //   sctpBufferedAmount: 0,
          //   sendBufferSize: 262144,
          // };
          // params.sctpParameters = sctpParameters;

          console.log("signalNewConsumerTransport params ", params);

          let consumerTransport;
          try {
            consumerTransport = device.createRecvTransport(params);
            console.log("createRecvTransport");
          } catch (error) {
            console.log(error);
            return;
          }

          consumerTransport.on(
            "connect",
            async ({ dtlsParameters }: any, callback: any, errback: any) => {
              try {
                await socket.emit("transport-recv-connect", {
                  // transportId: producerTransport.id,
                  dtlsParameters,
                  serverConsumerTransportId: params.id,
                });

                callback();
              } catch (error) {
                errback(error);
              }
            }
          );

          connectRecvTransport(consumerTransport, remoteProducerId, params.id);
        }
      );
    };
    const connectSendTransport = async () => {
      console.log("videoParams", videoParams);
      videoProducer = await producerTransport.produce(videoParams);
      // videoProducer.setMaxIncomingBitrate(1)
      audioProducer = await producerTransport.produce(audioParams);

      videoProducer.on("trackended", () => {
        console.log("video track ended");
      });

      videoProducer.on("transportclose", () => {
        console.log("video transport close");
      });

      audioProducer.on("trackended", () => {
        console.log("audio track ended");
      });

      audioProducer.on("transportclose", () => {
        console.log("audio transport close");
      });
    };

    const connectRecvTransport = async (
      consumerTransport: any,
      remoteProducerId: any,
      serverConsumerTransportId: any
    ) => {
      console.log("connectRecvTransport");
      isHosting.value = false;
      hasProducer.value = true;
      await socket.emit(
        "consume",
        {
          rtpCapabilities: device.rtpCapabilities,
          remoteProducerId,
          serverConsumerTransportId,
        },
        async ({ params }: any) => {
          if (params.error) {
            console.log("cannot consume", params.error);
            return;
          }
          console.log(params);
          const consumer = await consumerTransport.consume({
            id: params.id,
            producerId: params.producerId,
            kind: params.kind,
            rtpParameters: params.rtpParameters,
            // enableRtx: true,
            // jitterBufferDelayHint: 500,
          });

          consumerTransports = [
            ...consumerTransports,
            {
              consumerTransport,
              serverConsumerTransportId: params.id,
              producerId: remoteProducerId,
              consumer,
            },
          ];
          console.log("consumer", consumer);
          const { track } = consumer;
          // consumer.playoutDelayHint = 1;
          // consumer.jitterBufferDelayHint = 1;

          // await consumer.updateRtpParameters({
          //   encodings: [{ maxBitrate: 5000000, dtx: false }],
          // });

          // await consumer.setPreferredLayers({
          //   spatialLayer: 1,
          //   temporalLayer: 2,
          // });

          console.log("recv track", consumer);

          setInterval(async () => {
            console.log(await consumer.getStats());
          }, 1000);
          // track.addTrack(audioTrack)
          const newEle = document.createElement("div");
          newEle.setAttribute("id", `c-${remoteProducerId}`);
          let c: any;

          if (params.kind == "audio") {
            newEle.innerHTML =
              '<audio id="' + remoteProducerId + '" autoplay></audio>';
            document.getElementById("mediaContainer")!.appendChild(newEle);
            c = document.getElementById("recvAudio");
            // c = newEle;
            c.srcObject = new MediaStream([track]);
            console.log(c);

            c.play();
          } else {
            // 'recvVideo'

            c = document.getElementById("recvVideo");
            c.srcObject = new MediaStream([track]);
            // c.srcObject = new MediaStream([track])
            // newEle.setAttribute('class', 'remoteVideo')
            // newEle.innerHTML = '<video id="' + remoteProducerId + '" autoplay class="video" ></video>'
          }

          // c.play()
          // document.getElementById('mediaContainer')!.appendChild(newEle)

          // c = document.getElementById(remoteProducerId)

          socket.emit("consumer-resume", {
            serverConsumerId: params.serverConsumerId,
          });
        }
      );
    };

    socket.on("producer-closed", ({ remoteProducerId }: any) => {
      const producerToClose = consumerTransports.find(
        (transportData) => transportData.producerId === remoteProducerId
      );
      producerToClose.consumerTransport.close();
      producerToClose.consumer.close();

      consumerTransports = consumerTransports.filter(
        (transportData) => transportData.producerId !== remoteProducerId
      );

      // TODO LIVE STREAM IS OVER
      console.log("Stream is over");
    });

    onMounted(() => {
      joinRoom();
    });
    return {
      playAudio1,
      isHosting,
      socket,
      users,
      nickname,
      hasProducer,
      getLocalStream,
      // getRtpCapabilities,
      createDevice,
      createSendTransport,
      connectSendTransport,
      connectRecvTransport,
      goLive,
      goConsume,
      joinRoom,
    };
  },
  components: { HanButtonVue },
});
